export function defaultBacktestPeriod(now = new Date()) {
  const end = new Date(now);
  const start = new Date(Date.UTC(end.getUTCFullYear() - 3, end.getUTCMonth(), end.getUTCDate()));
  return { from: start.toISOString().slice(0, 10), to: end.toISOString().slice(0, 10) };
}

// Migrate the old fixed demo range, whose 2026-01-01 end date excluded every
// security whose usable history started later in 2026 (including AFRINSURE).
export function migrateBacktestPeriod(config, now = new Date()) {
  if (config?.period?.from !== '2023-01-01' || config?.period?.to !== '2026-01-01') return config;
  return { ...config, period: defaultBacktestPeriod(now) };
}

function isIsoDate(value) {
  return typeof value === 'string'
    && /^\d{4}-\d{2}-\d{2}$/.test(value)
    && Number.isFinite(Date.parse(value))
    && new Date(`${value}T00:00:00.000Z`).toISOString().slice(0, 10) === value;
}

export function backtestPeriodError(period) {
  if (!isIsoDate(period?.from) || !isIsoDate(period?.to)) return 'Choose valid start and end dates.';
  if (period.from > period.to) return 'End date must be on or after the start date.';
  return '';
}

export function isBacktestPeriodValid(period) {
  return !backtestPeriodError(period);
}

export function assertValidBacktestPeriods(payload) {
  const periods = [];
  if (payload?.period) periods.push(payload.period);
  if (payload?.base?.period) periods.push(payload.base.period);
  for (const strategy of payload?.strategies || []) {
    if (strategy?.period) periods.push(strategy.period);
  }
  const error = periods.map(backtestPeriodError).find(Boolean);
  if (error) throw new Error(error);
}
